import React from 'react';
import AboutSection from '../components/AboutSection';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  return (
    <div className="about-us">
      <h1>About Us</h1>
      <AboutSection title="Who We Are" description="A proud member of the greater DC/MD/VA Metropolitan community and we've enjoyed serving you since 1999.  We hope to get the opportunity to meet you in person and until then, let us introduce you to our business, managing philosophy and services. " />
      <AboutSection title="Core Services" description="Our core services are: scrap tire removal/processing and scrap metal removal/ processing.  We also provide additional services to our customers of junk removal.  We'll also introduce you to some of our trusted business partners for other services you may need or for which you might be ready for a change of vendors." />
      <AboutSection title="Our Mission" description="Our mission is to reduce waste by recycling tires into valuable materials." />
    </div>
  );
};

export default AboutUs;
